import styled from '@emotion/styled';

export const ShelfTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
